// DOM cache
const els = {
  qty: document.querySelector('input[name="quantity"]'),
  qtyWrap: document.querySelector('.product-form__quantity'),
  tech: document.getElementById('technical-resources'),
  desc: document.getElementById('product-desc-div'),
  mediaList: document.querySelector('.product__media-list'),
  regularPrices: Array.from(document.getElementsByClassName('price-item--regular')),
  salePrices: Array.from(document.getElementsByClassName('price-item--sale')),
  specLink: document.getElementById('spec-sheet-link'),
  instructionLink: document.getElementById('instruction-sheet-link'),
  dimensionLink: document.getElementById('dimension-sheet-link'),
  energyGuideLink: document.getElementById('energy-guide-link'),
  // CHANGED: looked up fresh each time. Both notes live inside #Stock-<section>, whose innerHTML
  // product-info.js replaces on every variant change, so a cached reference would go stale.
  get discontinuedNote() {
    return document.getElementById('variant-discontinued-note');
  },
  get showroomNote() {
    return document.getElementById('variant-showroom-note');
  },
  // NEW: main product info column (price / stock / SKU / fan details), used for the loading state
  get infoContainer() {
    return document.querySelector('product-info[id^="MainProduct-"] .product__info-container');
  }
};


// ---------------------------------------------------------------------------
// UTILITIES
// ---------------------------------------------------------------------------


function formatCash(amount) {
  return (Math.round(amount * 100) / 100).toFixed(2);
}


function writeTextList(nodes, text) {
  nodes.forEach((node) => {
    node.textContent = text;
  });
}


function toggleLink(link, href) {
  if (!link) return;
  if (href) {
    link.href = href;
    link.style.display = 'inline-flex';
  } else {
    link.removeAttribute('href');
    link.style.display = 'none';
  }
}


function getQtyValue() {
  return Math.max(1, parseInt(els.qty?.value, 10) || 0);
}


// ---------------------------------------------------------------------------
// VARIANT RESOLUTION
// ---------------------------------------------------------------------------


// CHANGED: an option group is either a button/swatch fieldset (fieldset.js, radios) or a dropdown
// (.product-form__input--dropdown, one <select>). snippets/product-variant-picker.liquid renders
// large groups (more than 24 values, or long value text) as dropdowns, so one product can mix both.
// Both match in document order, which is the option order (option1, option2, option3).
const OPTION_GROUP_SELECTOR = 'fieldset.js, .product-form__input--dropdown';


function getOptionGroups(picker) {
  return Array.from(picker.querySelectorAll(OPTION_GROUP_SELECTOR));
}


// Selected value of one option group, or null if none is selected
function readOptionGroupValue(group) {
  const select = group.querySelector('select');
  if (select) return select.selectedIndex >= 0 ? select.value : null;


  const checked = group.querySelector('input[type="radio"]:checked');
  return checked ? checked.value : null;
}


function getSelectedOptionValues() {
  const picker = document.querySelector('variant-selects, variant-radios');
  if (!picker) return [];


  return getOptionGroups(picker).map(readOptionGroupValue);
}


function hasAllOptionsSelected() {
  const picker = document.querySelector('variant-selects, variant-radios');
  if (!picker) return true;


  const groups = getOptionGroups(picker);
  if (!groups.length) return true;


  return groups.every((group) => readOptionGroupValue(group) !== null);
}


// CHANGED: variant data no longer comes from a window.ProductData.variants table. Liquid only
// returns the first 250 variants, so on larger products most variants could not be resolved.
// sections/main-product.liquid now renders ONE JSON block, for the selected variant only:
//   <script type="application/json" data-selected-variant-data>{...}</script>
// It is read from the page on load, and from the section HTML that Dawn's product-info.js
// fetches on every option change (PUB_SUB_EVENTS.variantChange -> event.data.html). Shopify
// renders that response for the exact selected variant, whatever the variant count.
const SELECTED_VARIANT_DATA_SELECTOR =
  'product-info[id^="MainProduct-"] script[data-selected-variant-data]';


// Data for the variant currently shown (null = no variant exists for the chosen options)
let currentVariantData = null;


// Product id of this page's main product; data for any other product (e.g. a quick-add modal) is ignored
let mainProductId = null;


// Returns the parsed data object, null (block says "no variant"), or undefined (no block / bad JSON)
function readSelectedVariantData(root) {
  if (!root || typeof root.querySelector !== 'function') return undefined;


  const node = root.querySelector(SELECTED_VARIANT_DATA_SELECTOR);
  if (!node) return undefined;


  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    console.error('product-variant-updater: could not parse selected variant data', error);
    return undefined;
  }
}


// Same rule the old resolveVariantFromSelectedOptions() used: the variant only counts as the
// "exact" variant if its option values equal the currently checked option buttons.
function variantMatchesSelectedOptions(variant) {
  const picker = document.querySelector('variant-selects, variant-radios');
  if (!picker) return true;


  const selected = getSelectedOptionValues();
  if (!selected.length || selected.some((v) => !v)) return false;


  const options =
    variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
  return selected.every((value, index) => options[index] === value);
}


function getExactVariantAndSelectionState(variantData) {
  const exactVariant =
    variantData && variantMatchesSelectedOptions(variantData) ? variantData : null;
  const allChosen = hasAllOptionsSelected();
  return { exactVariant, allChosen };
}


// ---------------------------------------------------------------------------
// LOADING STATE (NEW)
// ---------------------------------------------------------------------------


const VARIANT_LOADING_CLASS = 'is-variant-loading';
// Safety net: if the fetch fails (network error), un-dim the page after this long
const VARIANT_LOADING_TIMEOUT_MS = 10000;
// true from an option click until that change's data has been applied
let isVariantLoading = false;
let variantLoadingTimer = null;


function toggleVariantLoadingClass(on) {
  getVariantLoadingTargets().forEach((el) => {
    el.classList.toggle(VARIANT_LOADING_CLASS, on);
  });
}


function getVariantLoadingTargets() {
  return [
    els.infoContainer,
    els.desc,
    els.tech,
    els.mediaList || document.querySelector('.product__media-list')
  ].filter(Boolean);
}


function setVariantLoading(on) {
  isVariantLoading = !!on;
  clearTimeout(variantLoadingTimer);
  variantLoadingTimer = null;


  toggleVariantLoadingClass(isVariantLoading);


  if (isVariantLoading) {
    variantLoadingTimer = setTimeout(() => toggleVariantLoadingClass(false), VARIANT_LOADING_TIMEOUT_MS);
  }
}


// True only for option changes made inside this page's main product form
function isMainProductTarget(target) {
  if (!target || typeof target.closest !== 'function') return false;


  const productInfo = target.closest('product-info');
  if (!productInfo || productInfo.dataset.originalSection) return false;


  return !mainProductId || String(productInfo.dataset.productId) === String(mainProductId);
}


// ---------------------------------------------------------------------------
// MEDIA SYNC
// ---------------------------------------------------------------------------


// CHANGED: the main gallery now renders only the selected variant's media (featured image,
// its SKU|ALT|n images, and shared media), and Dawn's product-info.js swaps that set in on every
// variant change. So these were removed:
//  - reorderMediaForVariant(): nothing to reorder, other variants' media are not on the page
//  - click an image / thumbnail to select its variant (initMediaClickVariantSync,
//    initThumbnailVariantSync, selectVariantById, syncRadiosToVariant): every rendered image
//    already belongs to the selected variant (or is shared)
//  - window.ProductData.mediaToVariant / mediaVariantOptions: no longer emitted by the Liquid
// When the selected variant has no media and the product has no shared media, the Liquid renders
// the "Image not available" placeholder slide itself (data-media-id ending in "-placeholder").
// This only mirrors that into the list's is-placeholder class, which the old code also set.
function updateVariantImagePlaceholder() {
  const mediaList = els.mediaList || document.querySelector('.product__media-list');
  if (!mediaList) return;

  mediaList.classList.toggle(
    'is-placeholder',
    !!mediaList.querySelector('li[data-media-id$="-placeholder"]')
  );
}


// ---------------------------------------------------------------------------
// PRICE / TECH
// ---------------------------------------------------------------------------


function setDisplayedPriceText(text) {
  writeTextList(els.regularPrices, text);
  writeTextList(els.salePrices, '');
}


function renderTechResources({ exactVariant, allChosen }) {
  if (!els.tech) return;


  if (!allChosen || !exactVariant) {
    els.tech.style.display = 'none';
    toggleLink(els.specLink, '');
    toggleLink(els.instructionLink, '');
    toggleLink(els.dimensionLink, '');
    toggleLink(els.energyGuideLink, '');
    return;
  }


  const hasAny =
    !!exactVariant.spec_sheet_url ||
    !!exactVariant.instruction_sheet_url ||
    !!exactVariant.dimension_sheet_url ||
    !!exactVariant.energy_guide_url;


  els.tech.style.display = hasAny ? 'block' : 'none';
  toggleLink(els.specLink, exactVariant.spec_sheet_url);
  toggleLink(els.instructionLink, exactVariant.instruction_sheet_url);
  toggleLink(els.dimensionLink, exactVariant.dimension_sheet_url);
  toggleLink(els.energyGuideLink, exactVariant.energy_guide_url);
}


// ---------------------------------------------------------------------------
// DESCRIPTION (variantFacts)
// ---------------------------------------------------------------------------


const initialDescriptionHtml = els.desc ? els.desc.innerHTML : '';
const FIFTY_CELL = ' style="width:50%;"';


function nlToBrRaw(value) {
  return String(value ?? '').replace(/\r\n|\r|\n/g, '<br>');
}


function hasValue(value) {
  return value != null && String(value).trim() !== '';
}


function clean(value) {
  return String(value).trim();
}


function row(label, value) {
  return `
    <tr>
      <td${FIFTY_CELL}>${label}</td>
      <td${FIFTY_CELL}>${value}</td>
    </tr>
  `;
}


function buildVariantFactsHtmlFromVariant(variant) {
  const f = variant.variantFacts || {};
  const title = (window.ProductData && window.ProductData.productTitle) || '';
  const brand = (window.ProductData && window.ProductData.productVendor) || '';


  if (!Object.values(f).some(hasValue)) return '';


  let html = '<section>';


  if (hasValue(title)) {
    html += `
      <header>
        <h2>${clean(title)}</h2>
      </header>
    `;
  }


  if (hasValue(brand)) {
    html += `
      <p><strong>Brand:</strong> ${clean(brand)}</p>
      <hr>
    `;
  }


  if (hasValue(f.long_description)) {
    html += `
      <section>
        <h3>Product Description</h3>
        <p>${clean(f.long_description)}</p>
      </section>
      <hr>
    `;
  }


  const hasDesign =
    hasValue(f.intro_date) ||
    hasValue(f.designer) ||
    hasValue(f.material) ||
    hasValue(f.crystal) ||
    hasValue(f.rooms);


  if (hasDesign) {
    html += `
      <section>
        <h3>Design &amp; Materials</h3>
        <table style="width:75%;">
    `;


    if (hasValue(f.intro_date)) html += row('Intro Date', clean(f.intro_date));
    if (hasValue(f.designer)) html += row('Designer', clean(f.designer));
    if (hasValue(f.material)) html += row('Material', clean(f.material));
    if (hasValue(f.crystal)) html += row('Crystal', clean(f.crystal));
    if (hasValue(f.rooms)) html += row('Suggested Rooms', clean(f.rooms));


    html += `
        </table>
      </section>
      <hr>
    `;
  }


  const hasDims = hasValue(f.dimensions) || hasValue(f.shipping_boxes);


  if (hasDims) {
    html += `
      <section>
        <h3>Dimensions &amp; Physical</h3>
        <table style="width:75%;">
    `;


    if (hasValue(f.dimensions)) html += row('Dimensions', nlToBrRaw(f.dimensions));
    if (hasValue(f.shipping_boxes)) html += row('Shipping Boxes', nlToBrRaw(f.shipping_boxes));


    html += `
        </table>
      </section>
      <hr>
    `;
  }


  const hasFan =
    hasValue(f.fan_rpm) ||
    hasValue(f.fan_airflow) ||
    hasValue(f.fan_electricity_use) ||
    hasValue(f.airflow_efficiency) ||
    hasValue(f.fan_controller) ||
    hasValue(f.fan_speeds) ||
    hasValue(f.reverse_air);


  if (hasFan) {
    html += `
      <section>
        <h3>Fan Specs</h3>
        <table style="width:75%;">
    `;


    if (hasValue(f.fan_rpm)) html += row('Fan RPM', clean(f.fan_rpm));
    if (hasValue(f.fan_airflow)) html += row('Fan Airflow', clean(f.fan_airflow));
    if (hasValue(f.fan_electricity_use)) html += row('Fan Electricity Use', clean(f.fan_electricity_use));
    if (hasValue(f.airflow_efficiency)) html += row('Airflow Efficiency', clean(f.airflow_efficiency));
    if (hasValue(f.fan_controller)) html += row('Fan Control', clean(f.fan_controller));
    if (hasValue(f.fan_speeds)) html += row('Fan Speeds', clean(f.fan_speeds));
    if (hasValue(f.reverse_air)) html += row('Fan Reversible', clean(f.reverse_air));


    html += `
        </table>
      </section>
      <hr>
    `;
  }


  const hasLighting =
    hasValue(f.light_source) ||
    hasValue(f.light_output) ||
    hasValue(f.delivered_lumens) ||
    hasValue(f.beam_spread) ||
    hasValue(f.color_temperature) ||
    hasValue(f.color_temperature_range) ||
    hasValue(f.cri) ||
    hasValue(f.rated_average_life) ||
    hasValue(f.bulbs_included) ||
    hasValue(f.bulb_details) ||
    hasValue(f.rod) ||
    hasValue(f.wire) ||
    hasValue(f.chain) ||
    hasValue(f.canopy) ||
    hasValue(f.motor_size) ||
    hasValue(f.extension_from_wall) ||
    hasValue(f.fan_mounting_system) ||
    hasValue(f.safety_rating) ||
    hasValue(f.voltage) ||
    hasValue(f.maximum_wattage) ||
    hasValue(f.dimmable) ||
    hasValue(f.energy_star) ||
    hasValue(f.energy_efficient) ||
    hasValue(f.manufacturer_warranty);


  if (hasLighting) {
    html += `
      <section>
        <h3>Lighting &amp; Electrical Specs</h3>
    `;


    const hasGeneralLight =
      hasValue(f.light_source) ||
      hasValue(f.light_output) ||
      hasValue(f.delivered_lumens) ||
      hasValue(f.beam_spread) ||
      hasValue(f.color_temperature) ||
      hasValue(f.color_temperature_range) ||
      hasValue(f.cri) ||
      hasValue(f.rated_average_life);


    if (hasGeneralLight) {
      html += `
        <h4>General Light Specs</h4>
        <table style="width:75%;">
      `;


      if (hasValue(f.light_source)) html += row('Light Source', clean(f.light_source));
      if (hasValue(f.light_output)) html += row('Light Output', clean(f.light_output));
      if (hasValue(f.delivered_lumens)) html += row('Delivered Lumens', clean(f.delivered_lumens));
      if (hasValue(f.beam_spread)) html += row('Beam Spread', clean(f.beam_spread));
      if (hasValue(f.color_temperature)) html += row('Color Temperature', clean(f.color_temperature));
      if (hasValue(f.color_temperature_range)) html += row('Color Temperature Range', clean(f.color_temperature_range));
      if (hasValue(f.cri)) html += row('CRI', clean(f.cri));
      if (hasValue(f.rated_average_life)) html += row('Rated Average Life', clean(f.rated_average_life));


      html += `
        </table>
      `;
    }


    const hasBulb = hasValue(f.bulbs_included) || hasValue(f.bulb_details);


    if (hasBulb) {
      html += `
        <h4>Bulb Details</h4>
        <table style="width:75%;">
      `;


      if (hasValue(f.bulbs_included)) html += row('Bulbs Included', clean(f.bulbs_included));
      if (hasValue(f.bulb_details)) html += row('Bulb Details', nlToBrRaw(f.bulb_details));


      html += `
        </table>
      `;
    }


    const hasHardware =
      hasValue(f.rod) ||
      hasValue(f.wire) ||
      hasValue(f.chain) ||
      hasValue(f.canopy) ||
      hasValue(f.motor_size) ||
      hasValue(f.extension_from_wall) ||
      hasValue(f.fan_mounting_system);


    if (hasHardware) {
      html += `
        <h4>Hardware</h4>
        <table style="width:75%;">
      `;


      if (hasValue(f.rod)) html += row('Rod', clean(f.rod));
      if (hasValue(f.wire)) html += row('Wire', clean(f.wire));
      if (hasValue(f.chain)) html += row('Chain', clean(f.chain));
      if (hasValue(f.canopy)) html += row('Canopy', clean(f.canopy));
      if (hasValue(f.motor_size)) html += row('Motor Size', clean(f.motor_size));
      if (hasValue(f.extension_from_wall)) html += row('Extension from Wall', clean(f.extension_from_wall));
      if (hasValue(f.fan_mounting_system)) html += row('Fan Mounting System', clean(f.fan_mounting_system));


      html += `
        </table>
      `;
    }


    const hasElectrical =
      hasValue(f.safety_rating) ||
      hasValue(f.voltage) ||
      hasValue(f.maximum_wattage) ||
      hasValue(f.dimmable);


    if (hasElectrical) {
      html += `
        <h4>Electrical</h4>
        <table style="width:75%;">
      `;


      if (hasValue(f.safety_rating)) html += row('Safety Rating', clean(f.safety_rating));
      if (hasValue(f.voltage)) html += row('Voltage', clean(f.voltage));
      if (hasValue(f.maximum_wattage)) html += row('Maximum Wattage', clean(f.maximum_wattage));


      const rawDim = String(f.dimmable ?? '').toLowerCase().trim();
      let dimDisplay;
      if (!rawDim) dimDisplay = 'Not Listed';
      else if (rawDim.includes('yes')) dimDisplay = 'Yes*';
      else if (rawDim.includes('no')) dimDisplay = 'No*';
      else dimDisplay = clean(f.dimmable);


      html += row('Dimmable', dimDisplay);


      html += `
        </table>
      `;
    }


    const hasEnergy = hasValue(f.energy_star) || hasValue(f.energy_efficient);


    if (hasEnergy) {
      html += `
        <h4>Energy &amp; Efficiency</h4>
        <table style="width:75%;">
      `;


      if (hasValue(f.energy_star)) html += row('Energy Star', clean(f.energy_star));
      if (hasValue(f.energy_efficient)) html += row('Energy Efficient', clean(f.energy_efficient));


      html += `
        </table>
      `;
    }


    if (hasValue(f.manufacturer_warranty)) {
      html += `
        <h4>Manufacturer Warranty</h4>
        <table style="width:75%;">
          ${row('Manufacturer Warranty', clean(f.manufacturer_warranty))}
        </table>
      `;
    }


    html += `
      </section>
    `;
  }


  html += '</section>';
  return html;
}


function renderDescription(currentVariant) {
  if (!els.desc) return;


  if (!currentVariant || !currentVariant.variantFacts) {
    els.desc.innerHTML = initialDescriptionHtml;
    return;
  }


  const html = buildVariantFactsHtmlFromVariant(currentVariant);
  els.desc.innerHTML = html || initialDescriptionHtml;
}


// ---------------------------------------------------------------------------
// MEDIA STATE
// ---------------------------------------------------------------------------


// CHANGED: no media reordering any more (see MEDIA SYNC); only the placeholder class is synced
function renderMediaState({ exactVariant, allChosen }) {
  updateVariantImagePlaceholder();


  if (!els.mediaList) return;


  if (!els.mediaList.dataset.overlayClickBound) {
    els.mediaList.addEventListener('click', function () {
      els.mediaList.classList.add('hide-overlay-text');
    });
    els.mediaList.dataset.overlayClickBound = 'true';
  }


  els.mediaList.classList.remove(
    'is-incomplete',
    'is-unavailable',
    'is-oos',
    'is-backordered',
    'is-discontinued',                                   // NEW
    'hide-overlay-text'
  );


  if (!allChosen) {
    els.mediaList.classList.add('is-incomplete');
    return;
  }


  if (!exactVariant) {
    els.mediaList.classList.add('is-unavailable');
    return;
  }

  // Prefer Shopify-style inventory_quantity if present; fall back to inventory
  const rawInventory =
    exactVariant.inventory_quantity != null
      ? exactVariant.inventory_quantity
      : exactVariant.inventory;
  const inventory = Number(rawInventory || 0);
  const policy = exactVariant.inventory_policy;

  // In stock: any positive quantity, regardless of policy
  if (inventory > 0) {
    if (exactVariant.discontinued === true) {            // NEW
      els.mediaList.classList.add('is-discontinued');    // NEW: while supplies last
    }                                                    // NEW
    return;
  }

  // Discontinued, no stock
  if (inventory <= 0 && exactVariant.discontinued === true) {
    els.mediaList.classList.add('is-oos');
    return;
  }

  // Made to order: sellable with a lead time, shown next to the price; photo stays clear
  if (inventory <= 0 && policy === 'continue' && exactVariant.lead_time) {
    return;
  }

  // Backordered: zero or negative inventory but allowed to continue selling
  if (inventory <= 0 && policy === 'continue') {
    els.mediaList.classList.add('is-backordered');
    return;
  }

  // Deny policy with zero stock = out of stock
  els.mediaList.classList.add('is-oos');
}


// NEW: discontinued note in the inventory block
function renderDiscontinued({ exactVariant, allChosen }) {
  const el = els.discontinuedNote;
  if (!el) return;

  if (!allChosen || !exactVariant || exactVariant.discontinued !== true) {
    el.hidden = true;
    return;
  }

  const rawInventory =
    exactVariant.inventory_quantity != null
      ? exactVariant.inventory_quantity
      : exactVariant.inventory;

  el.textContent = Number(rawInventory || 0) > 0
    ? 'Discontinued by the manufacturer: available only while supplies last.'
    : 'Discontinued by the manufacturer: no longer available.';
  el.hidden = false;
}

// NEW: showroom pickup badge in the inventory block
function renderShowroom({ exactVariant, allChosen }) {
  const el = els.showroomNote;
  if (!el) return;
  el.hidden = !(allChosen && exactVariant && exactVariant.in_showroom === true);
}

// ---------------------------------------------------------------------------
// RENDER LAYERS
// ---------------------------------------------------------------------------



function renderValueState() {
  const state = getExactVariantAndSelectionState(currentVariantData);
}


// CHANGED: renders from the selected-variant data block instead of window.ProductData.variants
function renderVariantState(variantData = currentVariantData) {
  const state = getExactVariantAndSelectionState(variantData);
  const currentVariant = variantData || null;


  renderTechResources(state);
  renderDescription(currentVariant);
  renderMediaState(state);
  renderDiscontinued(state);
  renderShowroom(state);
}


// NEW: store the new variant data, re-render everything, and clear the loading state
function applyVariantData(variantData) {
  currentVariantData = variantData || null;


  try {
    renderVariantState(currentVariantData);
  } finally {
    setVariantLoading(false);
    restoreDropdownFocus(); // NEW
  }
}



// ---------------------------------------------------------------------------
// LARGE OPTION GROUPS AS DROPDOWNS (NEW)
// ---------------------------------------------------------------------------


// Dawn's product-info.js replaces the whole <variant-selects> after every option change, then
// focuses the element whose id the change came from. For a <select> that is the chosen <option>,
// which cannot take focus, so keyboard focus is lost (with arrow keys on a closed select, each key
// press is a change). Remember the select's id (stable: rendered by Liquid as Option-<section>-<n>)
// and put focus back on the new select once the response is applied.
let dropdownToRefocusId = null;


function rememberDropdownFocus(target) {
  const select = target && target.tagName === 'OPTION' ? target.closest('select') : null;
  dropdownToRefocusId = select && document.activeElement === select ? select.id : null;
}


function restoreDropdownFocus() {
  const id = dropdownToRefocusId;
  dropdownToRefocusId = null;
  if (!id) return;


  // Runs after product-info.js's own focus attempt (a promise callback in the same response)
  setTimeout(() => {
    const select = document.getElementById(id);
    if (!select || select === document.activeElement) return;


    const active = document.activeElement;
    const focusIsLost =
      !active ||
      active === document.body ||
      !active.isConnected ||
      !!active.closest('variant-selects[style*="display: none"]');
    if (focusIsLost) select.focus({ preventScroll: true });
  }, 0);
}


// Shows the full text of the new value under a large dropdown right away; the section re-render
// replaces this element with the server-rendered one a moment later.
const SELECTED_VALUE_TEXT_MIN_LENGTH = 41; // same 40-character rule as the Liquid


function updateSelectedValueText(target) {
  const select = target && target.tagName === 'OPTION' ? target.closest('select') : null;
  if (!select) return;


  const group = select.closest('.product-form__input--auto-dropdown');
  const textNode = group && group.querySelector('[data-selected-value-text]');
  if (!textNode) return;


  textNode.textContent = select.value;
  textNode.hidden = select.value.length < SELECTED_VALUE_TEXT_MIN_LENGTH;
}


// ---------------------------------------------------------------------------
// EVENTS
// ---------------------------------------------------------------------------


// NEW: an option button was clicked in the main product form -> show the loading state
// until the new variant's data arrives.
function handleOptionValueSelectionChange(payload) {
  const target = payload?.data?.event?.target;
  if (!isMainProductTarget(target)) return;


  rememberDropdownFocus(target);
  updateSelectedValueText(target);
  setVariantLoading(true);
}


// CHANGED: product-info.js fires 'dawn:variant-updated' BEFORE it swaps price/stock/media.
//  - variant is null (no variant for this combination): product-info.js stops there and never
//    publishes variantChange, so render the unavailable state and clear loading here.
//  - otherwise: nothing to do yet; everything waits for the variantChange data below.
//    (CHANGED: this used to reorder the media here; see MEDIA SYNC.)
// Ignored unless the main product has a change in flight (keeps quick-add modals from
// touching the main page).
function handleVariantChange(evt) {
  if (!isVariantLoading) return;


  const variantFromEvent = evt?.detail?.variant || null;
  if (!variantFromEvent) {
    applyVariantData(null);
  }
}


// NEW: product-info.js publishes variantChange (after swapping price/stock) with the fetched
// section HTML; the selected variant's data block inside it is the source of truth.
function handleVariantChangePubSub(payload) {
  const html = payload?.data?.html;
  const variantFromEvent = payload?.data?.variant || null;

  const data = readSelectedVariantData(html);
  if (data === undefined) {
    // Response had no data block (should not happen): keep what is shown, just stop loading
    if (isVariantLoading) setVariantLoading(false);
    restoreDropdownFocus(); // NEW
    return;
  }


  // Another product's data (e.g. a quick-add modal): not ours
  if (data && mainProductId && String(data.product_id) !== String(mainProductId)) return;


  // Defensive: the data block and Dawn's own variant JSON come from the same response and
  // must agree. If they ever do not, show nothing rather than the wrong variant's specs.
  let resolved = data;
  if (resolved && variantFromEvent && String(resolved.id) !== String(variantFromEvent.id)) {
    console.warn('product-variant-updater: selected variant data does not match Dawn variant', resolved.id, variantFromEvent.id);
    resolved = null;
  }


  applyVariantData(resolved);
}


document.addEventListener('dawn:variant-updated', handleVariantChange);


if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionValueSelectionChange);
  subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChangePubSub);
} else {
  console.warn('product-variant-updater: Dawn pubsub not available; variant details will not update on option change');
}


// NEW: initial state = the variant the page was rendered with (honours ?variant=...)
{
  const mainProductInfo = document.querySelector('product-info[id^="MainProduct-"]');
  mainProductId = (mainProductInfo && mainProductInfo.dataset.productId) || null;


  const initialData = readSelectedVariantData(document);
  currentVariantData = initialData || null;
  if (!mainProductId && currentVariantData) mainProductId = currentVariantData.product_id;
}


if (els.qtyWrap) {
  els.qtyWrap.querySelectorAll('.quantity__button').forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(renderValueState, 0);
    });
  });
}


if (els.qty) {
  els.qty.addEventListener('input', renderValueState);
}


document.addEventListener('DOMContentLoaded', () => {
  renderVariantState();
});